// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateOrderApprovalSearchFields from "@insite/client-framework/Store/Pages/OrderApprovalList/Handlers/UpdateSearchFields";
import updateOrderHistorySearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import useShipToPicker from "@store/Framework/Common/Hooks/useShipToPicker";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
    orderApproval?: boolean;
}
const ShipToSelector: React.FC<Props> = ({ orderApproval = false }) => {
    const dispatch = useAppDispatch();
    const selectedOrderHistoryCustomerSequences = useSelector(
        (state: ApplicationState) => state.pages.orderHistory.getOrdersParameter.customerSequences,
    )?.split(",");
    const selectedOrderApprovalCustomerSequences = useSelector(
        (state: ApplicationState) => state.pages.orderApprovalList.getOrderApprovalsParameter.customerSequences,
    )?.split(",");
    const selectedCustomerSequences = orderApproval
        ? selectedOrderApprovalCustomerSequences
        : selectedOrderHistoryCustomerSequences;

    const updateSearchFields = orderApproval ? updateOrderApprovalSearchFields : updateOrderHistorySearchFields;
    const handleUpdateSearchFields = (selectedItems: string[]) => {
        dispatch(updateSearchFields({ customerSequences: selectedItems.join(",") }));
    };

    const { handleItemToggle, handleToggleAllItems, shipToDisplayNames, selectedCustomerSequenceNames } =
        useShipToPicker(handleUpdateSearchFields, selectedCustomerSequences);

    return (
        <ModalPicker
            header={translate("ShipTos")}
            toggleItem={handleItemToggle}
            toggleAllItems={handleToggleAllItems}
            data={shipToDisplayNames}
            selectedItems={selectedCustomerSequenceNames ?? []}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ShipToSelector,
    definition: {
        group: "Order History",
        displayName: "Ship Tos",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
export { ShipToSelector };
